import { combineReducers } from "redux";
import scenarioReducer from "app/scenarios/duck/slices";
import cycleReducer from "app/common/cycle/duck/slices";
import dataloadReducer from "app/common/dataload/duck/slices";
import catalogReducer from "app/common/catalog/duck/slices";
import retailersReducer from "app/common/retailer/duck/slices";
import retailersGroupReducer from "app/common/retailers_group/duck/slices";
import companiesReducer from "app/common/companies/duck/slices";
import areasReducer from "app/common/area/duck/slices";
import metadataReducer from "app/common/metadata/duck/slices";
import filtersReducer from "app/filters/duck/slices";
import historicsReducer from "app/history/duck/slices";
import elasticitiesReducer from "app/elasticity/duck/slices";
import estimationsReducer from "app/estimations/duck/slices";
import authReducer from "app/auth/duck/slices";
import competitorsReducer from "app/competitors/duck/slices";
import viewReducer from "app/common/view/duck/slices";
import tasksReducer from "app/common/task/duck/slices";
import recommendationEngineReducer from "app/recommendation-engine/duck/slices";
import summaryReducer from "app/summary/duck/slices";

const appReducer = combineReducers({
  scenarios: scenarioReducer,
  cycle: cycleReducer,
  dataload: dataloadReducer,
  metadata: metadataReducer,
  historics: historicsReducer,
  filters: filtersReducer,
  catalog: catalogReducer,
  retailers: retailersReducer,
  retailersGroup: retailersGroupReducer,
  areas: areasReducer,
  estimations: estimationsReducer,
  auth: authReducer,
  elasticities: elasticitiesReducer,
  competitors: competitorsReducer,
  companies: companiesReducer,
  view: viewReducer,
  tasks: tasksReducer,
  recommendationEngine: recommendationEngineReducer,
  summary: summaryReducer,
});

const rootReducer = (state, action) => {
  let newState = { ...state };

  if (action.type === "USER_LOGOUT") {
    newState = undefined;
  }

  return appReducer(newState, action);
};

export default rootReducer;
